/** iPhone, iPad, and iPadOS (which reports itself as a Mac but has a touch screen). Every browser on iOS shows only page 1 of a PDF inside an iframe. */
export function isIos(userAgent: string, platform: string, touchPoints: number): boolean {
  return /iphone|ipad|ipod/i.test(userAgent) || (/mac/i.test(platform) && touchPoints > 1);
}

/** Most pixels one canvas may hold on iOS (about 16 million) before Safari refuses to draw it. */
const MAX_CANVAS_PIXELS = 16_000_000;

/** CSS size of a page fitted to `containerWidth` at `zoom` percent, and the scale to draw it at (device pixels per PDF point), lowered if the canvas would be too big. */
export function fitPage(pageWidth: number, pageHeight: number, containerWidth: number, zoom: number, dpr: number) {
  const cssScale = (containerWidth * zoom) / 100 / pageWidth;
  const cssWidth = pageWidth * cssScale;
  const cssHeight = pageHeight * cssScale;
  const ratio = Math.min(dpr, Math.sqrt(MAX_CANVAS_PIXELS / (cssWidth * cssHeight)));
  return { cssWidth, cssHeight, renderScale: cssScale * ratio };
}

/** The 1-based page that fills most of the view: the last page whose top is at or above the middle of the viewport. `tops` are page tops relative to the scroll container's content. */
export function pageAtScroll(tops: number[], scrollTop: number, viewportHeight: number): number {
  const middle = scrollTop + viewportHeight / 2;
  let page = 1;
  tops.forEach((top, i) => { if (top <= middle) page = i + 1; });
  return page;
}
